export default {
    getList: {
        getWarningList: async function (params) {
            let option = {
                url: '/api/v1/user/alerts',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userWarningList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getStatusList: async function (params) {
            let option = {
                url: '/api/v1/partner/dropdown/statuses',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userWarningList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/user/site' + '/' + params.site_id,
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userWarningList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    }
}